import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  IconButton,
  useDisclosure,
  useColorModeValue,
} from "@chakra-ui/react";
import { BellIcon } from "@chakra-ui/icons";
import SidebarResponsive from "components/Sidebar/SidebarResponsive";
import PropTypes from "prop-types";
import { NavLink, useLocation } from "react-router-dom";
import NotificationDrawer from "views/Dashboard/Notifications/components/NotificationDrawer";
import { ProfileIcon, SettingsIcon } from "components/Icons/Icons";
import routes from "routes/routes";
import { useSelector, useDispatch } from "react-redux";
import { fetchNotificationsAction } from "state/actions/notificationActions";

export default function HeaderLinks(props) {
  const { variant, children, fixed, secondary, onOpen, ...rest } = props;
  const { isOpen, onOpen: openDrawer, onClose } = useDisclosure();
  const location = useLocation();
  const dispatch = useDispatch();

  const notifications = useSelector((state) => state.notifications.notifications);
  const loading = useSelector((state) => state.notifications.loading);
  const error = useSelector((state) => state.notifications.error);
  const hasMore = useSelector((state) => state.notifications.hasMore);
  const currentPage = useSelector((state) => state.notifications.page);

  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(fetchNotificationsAction(null, null, 1, 10));
    setPage(1);
  }, [dispatch]);

  const loadMoreNotifications = () => {
    if (!loading && hasMore) {
      const nextPage = page + 1;
      dispatch(fetchNotificationsAction(null, null, nextPage, 10));
      setPage(nextPage);
    }
  };

  const unreadCount = notifications?.notifications?.filter((n) => n.read_status === "Unread").length;
  const isAdminProfile = location.pathname === "/admin/profile";
  let navbarIcon = isAdminProfile ? "white" : useColorModeValue("gray.500", "gray.200");

  return (
    <Flex pe={{ sm: "0px", md: "16px" }} w={{ sm: "100%", md: "auto" }} alignItems="center">
      <SidebarResponsive
        logoText={props.logoText}
        secondary={props.secondary}
        routes={routes.filter((route) => route.visible !== false)}
        {...rest}
      />

      <NavLink to="/admin/profile">
        <ProfileIcon
          cursor="pointer"
          ms={{ base: "16px", xl: "0px" }}
          me="16px"
          color={navbarIcon}
          w="19px"
          h="19px"
        />
      </NavLink>

      <SettingsIcon
        cursor="pointer"
        me="16px"
        onClick={props.onOpen}
        color={navbarIcon}
        w="18px"
        h="18px"
      />

      <Box position="relative">
        <IconButton
          aria-label="Notifications"
          icon={<BellIcon color={navbarIcon} w="20px" h="20px" />}
          onClick={openDrawer}
          variant="ghost"
        />
        {unreadCount > 0 && (
          <Box
            position="absolute"
            top="7px"
            right="3px"
            bg="#FAA61A"
            color="white"
            fontSize="10px"
            fontWeight="bold"
            borderRadius="full"
            w="18px"
            h="13px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {unreadCount}
          </Box>
        )}
      </Box>

      <NotificationDrawer
        isOpen={isOpen}
        onClose={onClose}
        notifications={notifications?.notifications}
        loading={loading}
        loadMore={loadMoreNotifications}
        hasMore={hasMore}
      />
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
